import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    allAccounts: 'All accounts',
    createAccount: 'Create an account',
    createAssociatedAccount: 'Create a wallet',
    mainAccount: 'Main account',
    yourAccounts: 'Your accounts',
  },
  fr: {
    allAccounts: 'Tous les comptes',
    createAccount: 'Créer un sous-compte',
    createAssociatedAccount: 'Créer un sous-compte',
    mainAccount: 'Compte principal',
    yourAccounts: 'Vos comptes',
  },
} as const);

export default locales;
